import * as Sentry from '@sentry/angular';
import { bootstrapApplication } from '@angular/platform-browser';
import { environment } from './environments/environment';
import { LicenseManager } from 'ag-grid-enterprise';
import { config, loadRuntimeConfig } from './app/runtime-config';

async function main(): Promise<void> {
  await loadRuntimeConfig();
  const { sentry } = config();

  if (sentry.dsn) {
    Sentry.init({
      dsn: sentry.dsn,
      environment: sentry.environment,
      enableLogs: sentry.enableLogs,
      sendDefaultPii: sentry.sendDefaultPii,
    });
  }

  LicenseManager.setLicenseKey(environment.agGridLicenseKey);

  // Imported dynamically, and only now: a static import would be evaluated before this
  // function ever runs, and the app graph reads the runtime config at module scope
  // (`app.routes.ts` builds its routes from the feature flags).
  const [{ appConfig }, { AppComponent }] = await Promise.all([
    import('./app/app.config'),
    import('./app/app.component'),
  ]);

  await bootstrapApplication(AppComponent, appConfig);
}

main().catch(err => console.error(err));
